module.exports = __webpack_public_path__ + "img/amx-22.84ad4974.webp";